import React from 'react';
import sample from 'lodash/sample';
export const ActionBarContext = /*#__PURE__*/ React.createContext('primary');
ActionBarContext.displayName = 'ActionBarContext';
export const SecondaryActionBarContext = /*#__PURE__*/ React.createContext({
    setTopActionBarRef: ()=>null
});
SecondaryActionBarContext.displayName = 'SecondaryActionBarContext';
/**
 * Holds a boolean that tells us if any dialog is shown by our ActionBar controls.
 */ export const ActionBarDialogContext = /*#__PURE__*/ React.createContext(false);
/**
 * Holds a boolean for Adoptables offer context
 */ const randomOfferSetting = sample([
    true,
    false
]);
export const ActionBarAdoptablesOfferContext = /*#__PURE__*/ React.createContext(!!randomOfferSetting);
export const ActionBarAdoptablesBuyItNowContext = /*#__PURE__*/ React.createContext(!randomOfferSetting ? true : !!sample([
    true,
    false
]));
